export default __webpack_public_path__ + "static/Westpac logo-f517518e762d433a0cb1a70cc2170672.png";